import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoClientsKeys } from "Api/Queries/SsoClients/useSsoClientsQuery";
import {
  postSsoClients,
  type SsoClientRegisteredDto,
  type SsoClientRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SsoClientRegisteredDto) => void;
  onError?: (error: unknown) => void;
};

export const useRegisterSsoClientMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((data: SsoClientRequest) =>
      postSsoClients(data),
    ),
    onSuccess: (data: SsoClientRegisteredDto) => {
      queryClient.invalidateQueries({ queryKey: ssoClientsKeys.all });
      onSuccess?.(data);
    },
    onError,
  });
};
